var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
export function HeadphoneCheckModalContent() {
    return _jsx("div", __assign({ className: 'w-full mb-4' }, { children: _jsxs("ul", __assign({ className: "flex flex-col gap-4 items-center md:list-disc md:list-inside" }, { children: [_jsx(Typography, __assign({ component: "li", variant: "body1", className: 'font-medium md:font-bold text-sm' }, { children: "Make sure your headphones are plugged in, paired, or connected." })), _jsx(Typography, __assign({ component: "li", variant: "body1", className: 'font-medium md:font-bold text-sm' }, { children: "Check your volume and mute settings." })), _jsx(Typography, __assign({ component: "li", variant: "body1", className: 'font-medium md:font-bold text-sm' }, { children: "For best results, use Chrome, Safari, Firefox, or the latest version of Edge." }))] })) }));
}
